/**
 * Per-payment-line idempotency (same pattern as EditInvoice / sales update).
 * Existing lines resend the key from GET show; new lines get a stable generated key.
 */

export function readPaymentIdempotencyKeyFromApi(payment) {
  const idemRaw = payment?.idempotency_key ?? payment?.idempotencyKey ?? "";
  return idemRaw != null && String(idemRaw).trim() !== ""
    ? String(idemRaw).trim()
    : "";
}

export function readPaymentIdempotencyKeyFromRow(row) {
  const idemRaw = row?.paymentIdempotencyKey ?? "";
  return idemRaw != null && String(idemRaw).trim() !== ""
    ? String(idemRaw).trim()
    : "";
}

/**
 * @returns {{ idempotency_key?: string, generatedKey?: string }}
 */
export function resolvePaymentLineIdempotencyKey(row, hasExistingLine, createKey) {
  const storedKey = readPaymentIdempotencyKeyFromRow(row);

  if (hasExistingLine) {
    return storedKey ? { idempotency_key: storedKey } : {};
  }

  let lineKey = storedKey;
  let generatedKey;
  if (!lineKey) {
    lineKey = createKey();
    generatedKey = lineKey;
  }
  return { idempotency_key: lineKey, generatedKey };
}

export function hasExistingPaymentLineById(paymentId) {
  const pid =
    paymentId != null && paymentId !== "" ? Number(paymentId) : NaN;
  return Number.isFinite(pid) && pid > 0;
}
